export default "__VITE_ASSET__BlY3A$b6__"